import { render, staticRenderFns } from "./ConvoListTopics.vue?vue&type=template&id=22b3e960&scoped=true&"
import script from "./ConvoListTopics.vue?vue&type=script&lang=js&"
export * from "./ConvoListTopics.vue?vue&type=script&lang=js&"
import style0 from "./ConvoListTopics.vue?vue&type=style&index=0&id=22b3e960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b3e960",
  null
  
)

export default component.exports